import { render, staticRenderFns } from "./right_result.vue?vue&type=template&id=3a9e167d&scoped=true"
import script from "./right_result.vue?vue&type=script&lang=js"
export * from "./right_result.vue?vue&type=script&lang=js"
import style0 from "./right_result.vue?vue&type=style&index=0&id=3a9e167d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a9e167d",
  null
  
)

export default component.exports